<div class="disable__codigo">
  <div class="container__disable__codigo">
    <img
      src="./assets/images/icons/heart-broken.svg"
    />
    <p>{{screenSize <= 668 ? 'Indisponível para o seu nível' : tipoDisable + ' não está disponível para o seu nível'}}</p>
  </div>
</div>
